import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
    padding: `0 ${designTokens.spacing[6]}`,
    maxWidth: "720px",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    boxSizing: "border-box",
    paddingBottom: designTokens.spacing[6],
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing[4],
    flexShrink: 0,
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  headerIcon: {
    color: designTokens.neutral[500],
    width: "20px",
    height: "20px",
  },
  headerTitle: {
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.neutral[900],
  },
  searchBox: {
    width: "220px",
    padding: designTokens.spacing[2],
    borderRadius: designTokens.borderRadius.md,
    border: `1px solid ${designTokens.neutral[200]}`,
    backgroundColor: designTokens.neutral.white,
    "::after": {
      display: "none",
    },
    ":focus-within": {
      borderColor: designTokens.accent[500],
    },
  },
  groupLabel: {
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.neutral[500],
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    paddingTop: designTokens.spacing[2],
    gap: designTokens.spacing[2],
  },
  conversationCard: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: designTokens.spacing[3],
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    backgroundColor: designTokens.neutral.white,
    border: `1px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius.lg,
    cursor: "pointer",
    transition: `all ${designTokens.transition.fast}`,
    ":hover": {
      backgroundColor: designTokens.accent[50],
      borderColor: designTokens.accent[500],
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },
  chatIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    minWidth: "40px",
    borderRadius: designTokens.borderRadius.md,
    flexShrink: 0,
  },
  chatIconClaude: {
    backgroundColor: "#ECFDF5",
    color: "#16A34A",
  },
  chatIconOpenai: {
    backgroundColor: "#EFF6FF",
    color: "#0078D4",
  },
  chatIconDefault: {
    backgroundColor: designTokens.neutral[100],
    color: designTokens.neutral[500],
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
    gap: "2px",
  },
  cardTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  cardTitle: {
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.neutral[900],
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  tagPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.medium,
    color: designTokens.accent[700],
    backgroundColor: designTokens.accent[50],
    border: `1px solid ${designTokens.accent[200]}`,
    borderRadius: designTokens.borderRadius.md,
    padding: `1px ${designTokens.spacing[2]}`,
    whiteSpace: "nowrap",
  },
  tagIcon: {
    width: "12px",
    height: "12px",
  },
  cardSnippet: {
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[500],
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  cardMeta: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "2px",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  modelIndicator: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.medium,
  },
  modelIndicatorClaude: {
    color: "#16A34A",
  },
  modelIndicatorOpenai: {
    color: "#0078D4",
  },
  modelIndicatorDefault: {
    color: designTokens.neutral[700],
  },
  modelDot: {
    width: "8px",
    height: "8px",
    borderRadius: designTokens.borderRadius.full,
    flexShrink: 0,
  },
  modelDotClaude: {
    backgroundColor: "#16A34A",
  },
  modelDotOpenai: {
    backgroundColor: "#0078D4",
  },
  modelDotDefault: {
    backgroundColor: designTokens.neutral[500],
  },
  metaSubtext: {
    fontFamily: designTokens.fontFamily,
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[400],
  },
  arrowIcon: {
    color: designTokens.neutral[400],
    flexShrink: 0,
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: designTokens.spacing[8],
    fontFamily: designTokens.fontFamily,
    color: designTokens.neutral[500],
    fontSize: designTokens.fontSize.sm,
    textAlign: "center",
    gap: designTokens.spacing[2],
  },
  skeletonCard: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    border: `1px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius.lg,
  },
  skeletonIcon: {
    width: "40px",
    height: "40px",
    borderRadius: designTokens.borderRadius.md,
    backgroundColor: designTokens.neutral[100],
    flexShrink: 0,
  },
  skeletonContent: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    gap: designTokens.spacing[2],
  },
  skeletonTitle: {
    height: "14px",
    width: "50%",
    borderRadius: designTokens.borderRadius.sm,
    backgroundColor: designTokens.neutral[100],
  },
  skeletonDesc: {
    height: "10px",
    width: "70%",
    borderRadius: designTokens.borderRadius.sm,
    backgroundColor: designTokens.neutral[100],
  },
  listContainer: { display: "flex", flexDirection: "column", gap: "5px" },
});
